export default {
  name: 'name',
  code: 'code',
}
